module.exports = __webpack_public_path__ + "640c8adfc4a978974c645f685c32ab2a.png";